(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leio-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class LeioAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.leio-announcement-bar__slide'));
      this.current = 0;
      this.speed = parseInt(this.dataset.speed || '5000');
      this.bleed = this.dataset.bleed === 'true';
      this.bar = this.closest('.leio-announcement-bar');

      if (this.bleed) {
        this.syncThemeColor();
      }

      if (this.slides.length <= 1) return;

      this.show(0);
      this.interval = setInterval(() => this.next(), this.speed);

      this.querySelector('[data-prev]')?.addEventListener('click', () => {
        clearInterval(this.interval);
        this.prev();
        this.interval = setInterval(() => this.next(), this.speed);
      });

      this.querySelector('[data-next]')?.addEventListener('click', () => {
        clearInterval(this.interval);
        this.next();
        this.interval = setInterval(() => this.next(), this.speed);
      });
    }

    show(index) {
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
      });
      this.current = index;
    }

    next() {
      this.show((this.current + 1) % this.slides.length);
    }

    prev() {
      this.show((this.current - 1 + this.slides.length) % this.slides.length);
    }

    syncThemeColor() {
      const setColor = () => {
        if (!this.bar) return;
        let meta = document.getElementById('leio-theme-color');
        if (!meta) {
          meta = document.createElement('meta');
          meta.name = 'theme-color';
          meta.id = 'leio-theme-color';
          document.head.appendChild(meta);
        }
        const bg = getComputedStyle(this.bar).backgroundColor;
        const match = bg.match(/\d+/g);
        if (match && match.length >= 3 && bg !== 'rgba(0, 0, 0, 0)') {
          const hex = '#' + match.slice(0, 3).map(n =>
            ('0' + parseInt(n).toString(16)).slice(-2)
          ).join('');
          meta.setAttribute('content', hex);
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setColor);
      } else {
        setColor();
      }
    }
  }

  customElements.define('leio-announcement-bar', LeioAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
